<template>
  <div
    class="text-secondary text-style-sm bg-primary border border-secondary rounded-sm px-3 py-2 w-full"
  >
    <i18n-t
      :keypath="'tasks.activity.' + item.description"
      scope="global"
      tag="p"
      class="text-secondary text-style-sm font-normal first-letter:uppercase"
    >
      <template v-slot:causer>
        {{ item.user?.fullname || item.messenger?.name || "Anonymous" }}
      </template>
      <template v-slot:number>
        {{ task?.number }}
      </template>
      <template v-slot:time v-if="item.start_date && item.end_date">
        {{
          differenceInMinutes(
            new Date(item.end_date),
            new Date(item.start_date)
          )
        }}
      </template>
      <template v-slot:logged_for v-if="item.logged_for">
        {{ item.logged_for.fullname }}
      </template>
      <template v-slot:time_description v-if="item.time_description">
        "{{ item.time_description }}"
      </template>
      <template v-slot:material_description v-if="item.material_description">
        "{{ item.material_description }}"
      </template>
      <template v-slot:cost v-if="item.cost">
        {{ formatter.format(item.cost) }}
      </template>
      <template v-slot:date v-if="logDate">
        {{ new Date(logDate).toLocaleDateString() }}
      </template>
      <template v-slot:category v-if="item.category">
        {{ item.category.name }}
      </template>
      <template v-slot:priority v-if="item.priority">
        {{ item.priority.name }}
      </template>
      <template v-slot:scheduled_for v-if="item.scheduled_for">
        {{ scheduledFor }}
      </template>
      <template v-slot:assignees v-if="item.assignees">
        {{ assignees }}
      </template>
      <template v-slot:visibility>
        {{ visibility }}
      </template>
      <template v-slot:previous_description v-if="item.title">
        "{{ item.title.previous_description }}"
      </template>
      <template v-slot:current_description v-if="item.title">
        "{{ item.title.current_description }}"
      </template>
      <template v-slot:previous_space v-if="item.space">
        {{ item.space.previous_space.name }}
      </template>
      <template v-slot:current_space v-if="item.space">
        {{ item.space.current_space.name }}
      </template>
      <template
        v-slot:checklist_item_description
        v-if="item.checklist_item_description"
      >
        {{
          item.checklist_item_description.current ??
          item.checklist_item_description
        }}
      </template>
      <template
        v-slot:checklist_item_description_previous
        v-if="item.checklist_item_description"
      >
        {{ item.checklist_item_description.previous }}
      </template>
    </i18n-t>
  </div>
</template>

<script setup>
import { format, differenceInMinutes } from "date-fns";
import { computed } from "vue";
import { fromUTC } from "@/Utils/date";

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  task: {
    type: Object,
    default: () => {},
  },
});

const formatter = new Intl.NumberFormat("nl-BE", {
  style: "currency",
  currency: "EUR",
});

const logDate = computed(() => {
  const date = props.item.start_date || props.item.date;
  if (!date) {
    return;
  }

  return fromUTC(date);
});

const scheduledFor = computed(() => {
  return format(fromUTC(props.item.scheduled_for), "dd MMM YYY");
});

const assignees = computed(() => {
  const [assignee] = props.item.assignees;

  if (!assignee) {
    return false;
  }

  return assignee.fullname;
});

const visibility = computed(() => {
  return props.item.private ? "private" : "public";
});
</script>
